import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M8.00391 7.99805H6V10.002H8.00391V7.99805Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M8.00391 11.998H6V14.002H8.00391V11.998Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M8.00391 15.998H6V18.002H8.00391V15.998Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M7.44237 2H2V22H22V8.63795L16.4684 2H11V5.91339L7.44237 2ZM11 8.88661V20H4V4H6.55763L11 8.88661ZM15 7.99805H17.0039V10.002H15V7.99805ZM15 11.998H17.0039V14.002H15V11.998ZM17.0039 15.998V18.002H15V15.998H17.0039Z"}}]};

const TownFilled = Vue.extend<IconProps>({
  name: 'TownFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'town-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default TownFilled;
